import { formatDistanceToNowStrict, formatDistanceToNow } from 'date-fns'
import { enUS, fr, es, pl, ar, zhCN } from 'date-fns/locale'
import { useTranslation } from './i18n'

const dateLocales = {
  en: enUS,
  fr,
  es,
  pl,
  ar,
  zh: zhCN,
}

export function useDateI18n() {
  const { locale } = useTranslation()
  const dateFnsLocale = dateLocales[locale] || dateLocales.en

  const formatDistanceToNowStrictI18n = (date, options = {}) =>
    formatDistanceToNowStrict(date, {
      ...options,
      locale: dateFnsLocale,
    })

  const formatDistanceToNowI18n = (date, options = {}) =>
    formatDistanceToNow(date, {
      ...options,
      locale: dateFnsLocale,
    })

  return {
    formatDistanceToNowStrict: formatDistanceToNowStrictI18n,
    formatDistanceToNow: formatDistanceToNowI18n,
    locale: dateFnsLocale,
  }
}

export function formatDistanceToNowStrictWithLocale(
  date,
  locale = 'en',
  options = {}
) {
  const dateFnsLocale = dateLocales[locale] || dateLocales.en
  return formatDistanceToNowStrict(date, {
    ...options,
    locale: dateFnsLocale,
  })
}

export function formatDistanceToNowWithLocale(
  date,
  locale = 'en',
  options = {}
) {
  const dateFnsLocale = dateLocales[locale] || dateLocales.en
  return formatDistanceToNow(date, {
    ...options,
    locale: dateFnsLocale,
  })
}
